import WordPressContentPageHeader from './wordpress-content-page-header';
export default WordPressContentPageHeader;